/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Classification_Export_SuccessInputs */

const en_classification_export_success = /** @type {(inputs: Classification_Export_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classification results exported successfully`)
};

const nl_classification_export_success = /** @type {(inputs: Classification_Export_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificatieresultaten succesvol geexporteerd`)
};

/**
* | output |
* | --- |
* | "Classification results exported successfully" |
*
* @param {Classification_Export_SuccessInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const classification_export_success = /** @type {((inputs?: Classification_Export_SuccessInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Classification_Export_SuccessInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_classification_export_success(inputs)
	return en_classification_export_success(inputs)
});